import { SET_SETTINGS } from "./constants";

export const setSettings = routeName => (dispatch, getState) =>
	new Promise(resolve => {
		const { building } = getState().helpers;
		dispatch({
			type: SET_SETTINGS,
			routeName,
			building
		});
		resolve(routeName);
	});
export const getSettings = ({ state }) => () =>
	new Promise(resolve => {
		resolve(state);
	});
